import { LeftRight } from "@/components/LeftRight.tsx";
import { WSelect, type ConfiguredWSelectProps } from "@/components/forms/WSelect.tsx";
import type { ReactNode } from "react";

export interface SelectableHost {
    key: string;
    title: ReactNode;
    icon: ReactNode;
}

export interface LocationHostSelectProps extends ConfiguredWSelectProps<SelectableHost, string> {
    disabledKeys?: string[];
}

export function LocationHostSelectCustom(props: LocationHostSelectProps) {
    return (
        <WSelect aria-label="Location" getKey={(item) => item.key} {...props}>
            {(item) => <LeftRight icon={item.icon} title={item.title} />}
        </WSelect>
    );
}
